<div class = "reusable-form-component">
  <ion-label class = "label">{{ labelText }}</ion-label>
    <app-places-autocomplete [formatedAddress] = "formattedAddress" class = "reusable-form" (addressChanged) = "handleAddressChange($event)"></app-places-autocomplete>
</div>
